import { render, staticRenderFns } from "./iconBibliography.vue?vue&type=template&id=39f1b432"
import script from "./iconBibliography.vue?vue&type=script&lang=js"
export * from "./iconBibliography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports